import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './Title.scss';

interface ITitleProps {
  context?: IContent;
  headline: string;
  baseline: string;
  color: string;
}

const Title = ({ headline, baseline, color }: ITitleProps) => {
  return (
    <h2 className={`section-title${baseline ? " with-baseline" : ""}`} style={{ color }}>
      <span className="title-headline">{headline}</span>
      <span className="title-separator" style={{ backgroundColor: color }} />
      {baseline && (
        <span className="title-baseline">{baseline}</span>
      )}
    </h2>
  );
};

export default withContent(Title);
